export default {
  path: 'manage-type',
  component: () => import('@/views/Route'),
  children: [
    {
      path: '',
      name: 'Manage Type',
      component: () => import('@/views/menus/type/Index'),
      meta: {
        permission: true
      }
    }
  ]
}
